export default __webpack_public_path__ + "static/media/kolkata.2debd423.jpg";